import { render, staticRenderFns } from "./vipcompManage.vue?vue&type=template&id=16ce6697&"
import script from "./vipcompManage.vue?vue&type=script&lang=js&"
export * from "./vipcompManage.vue?vue&type=script&lang=js&"
import style0 from "./vipcompManage.vue?vue&type=style&index=0&id=16ce6697&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports